import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import {
	Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import Pagination from './../shared/pagination'

// import Multiselect from 'vue-multiselect'
// import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
	name: 'user',
	components: {
		Paginate,
		Pagination,
		VueElementLoading
	},
	data: function() {
		return {
			totalRows: 0,
			checkrole: '',
			currentPage: 1,
			totalPage: 0,
			pageLimit:10,
			modalShow: false,
			updateusermodal: false,
			editusermodal: false,
			addusermodal: false,
			useraction: '',
			listUserData: [],
			listRoleData: [],
			listClientData: [],
			listWarehouseData: [],
			props: [],
			// pageno: 0,
			// totalPage: 0,
			username: '',
			userid: '',
			rolename: '',
			isLoading: false,
			resultCount: '',
		  warehouse: '',
			model: {
				name: '',
				username: '',
				useremail: '',
				userpassword: '',
				userconfirmpassword: '',
				client: '',
				warehouse: '',
				roleid: '',
			},
			adduser: {
				fullname: '',
				email: '',
				password: '',
				confirmpassword: '',
				roleid: '',
				clientid: '',
				warehouseid: '',
				usertype: ''
			},
			checked_roleid: [],
			status: '',
			changestatus: '',
			count: 0,
			email: '',
			localuserid: 0,
			showwarehouse: false,
			showclient: false,
		}
	},
	created: function() {

	},
	mounted() {
		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.localuserid = userdetail.userid;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		this.pageno = 0
		// this.getUserData()
		this.getRoleList()
		this.getClientData()
		this.getWarehouseList()
	},
	methods: {

		addNewUser() {

			this.adduser.fullname = '',
				this.adduser.email = '',
				this.adduser.password = '',
				this.adduser.confirmpassword = '',
				this.adduser.roleid = '',
				this.adduser.clientid = '',
				this.adduser.warehouseid = '',
				this.adduser.usertype = '',
				this.adduser.warehouseid = '';
			this.adduser.clientid = '';
			this.showwarehouse = false;
			this.showclient = false;
			this.useraction = 'add',
				this.addusermodal = true,
				this.checked_roleid = [],
				this.$validator.reset();
			this.errors.clear();
		},
		closeAddUserModal() {
			this.addusermodal = false,
				this.$validator.reset();
			this.errors.clear();
		},
		closeStatusUserModal() {
			this.modalShow = false
		},


		getUserDataSearch() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.getUserData();
		},
		getUserData() {
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				return false;
			}
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: 10,
				fullname: this.username.trim(),
				email: this.email.trim(),
				warehouse:localStorage.getItem("selectedWarehouse")

			})
			this.isLoading = true;

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'userMaster',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}

				})
				.then(result => {
					this.listUserData = result.data.data;
					this.isLoading = false;
					this.totalRows = result.data.count
					this.resultCount = result.data.count
					if (this.totalRows < 10) {
						this.totalPage = 1
					} else {
						this.totalPage = Math.ceil(this.totalRows / 10)
					}
				}, error => {
					console.error(error)
				})
		},

		getRoleList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			this.input = ({})
			axios({
					method: "POST",
					url: apiUrl.api_url + "getRoleidname",
					data: this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listRoleData = result.data;

				}, error => {
					console.error(error)
				})
		},
		//to get client list
		getClientData() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			// this.input = ({
			// 	offset: 0,
			// 	limit: 10,
			// 	clientname: ""
			// })
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
					'data': {},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {

					this.listClientData = result.data.data;
				}, error => {
					console.error(error)
				})
		},
		//to get warehouse List
		getWarehouseList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			// this.input = ({
			// 	clientid: this.adduser.clientid,
			// });
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
					'data': {},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					this.listWarehouseData = result.data.data;
				}, error => {
					console.error(error)
				})
		},

		saveUser() {
			if (this.adduser.usertype == '' || this.adduser.usertype == null) {
				return false;
			}
			if (this.checked_roleid.toString() == '') {
				return false;
			}
			if (this.adduser.fullname == '' || this.adduser.fullname == null) {
				return false;
			}
			if (this.adduser.email == '' || this.adduser.email == null) {
				return false;
			}
			if (this.adduser.password == '' || this.adduser.password == null) {
				return false;
			} else if (this.adduser.password.length < 8) {
				this.$alertify.error("Password Must Be Minimum Of 8 Characters")
				return false;
			}
			if (this.adduser.confirmpassword == '' || this.adduser.confirmpassword == null) {
				return false;
			}

			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			if (this.adduser.password == this.adduser.confirmpassword) {
				this.input = ({
					fullname: this.adduser.fullname,
					email: this.adduser.email,
					password: this.adduser.password,
					confirmpassword: this.adduser.confirmpassword,
					roleid: this.checked_roleid.toString(),
					utype: this.adduser.usertype,
					createdby: this.localuserid
				});
				if (this.adduser.usertype == 'warehouse_user') {
					if (this.adduser.warehouseid == '' || this.adduser.warehouseid == null) {
						return false;
					} else {
						this.input.warehouseid = parseInt(this.adduser.warehouseid);
						this.input.clientid = null;
					}
				} else if (this.adduser.usertype == 'client_user') {
					if (this.adduser.clientid == '' || this.adduser.clientid == null) {
						return false;
					} else {
						this.input.warehouseid = null;
						this.input.clientid = parseInt(this.adduser.clientid);
					}
				} else {
					this.input.warehouseid = null;
					this.input.clientid = null;
				}
				this.isLoading = true;
				axios({
						method: 'POST',
						'url': apiUrl.api_url + 'SubmitUserData',
						'data': this.input,
						headers: {
							'Authorization': 'Bearer ' + myStr
						}
					})
					.then((response) => {
						if (response.data.errorCode == 0) {
							this.$alertify.success(response.data.msg);
							this.addusermodal = false
							this.getUserData();
							axios({
									method: 'POST',
									'url': apiUrl.api_url + 'createEncryptedJsonForAccess',
									'data': {},
									headers: {
										'Authorization': 'Bearer ' + myStr,
									}
								})
								.then((response2) => {
									if (response2.data.errorCode == 0) {
										// do nothing
									} else if (response2.data.errorCode == -1) {
										this.$alertify.error(response2.data.msg);
									}
								})
								.catch((httpException) => {
									console.error('exception is:::::::::', httpException)
								})
						} else if (response.data.errorCode == -1) {
							this.$alertify.error(response.data.msg)
						}
						this.isLoading = false;

					})
					.catch((httpException) => {
						console.error('exception is:::::::::', httpException)
					})
			} else {
				this.$alertify.error("Passwords Do Not Match")
			}
		},
		check(abc) {
			this.checked_roleid = []
			this.checked_roleid = abc.split(",");
		},
		getUserRowData(data) {
			this.$validator.reset();
			this.errors.clear();
			this.useraction = 'edit';
			this.addusermodal = true;
			this.adduser.fullname = data.fullname;
			this.adduser.email = data.email;
			this.adduser.password = data.password;
			this.adduser.clientid = data.clientid;
			this.adduser.warehouseid = data.warehouseid;
			this.checked_roleid = data.roleid.split(",");
			this.checkrole = data.roleid.split(",");
			//	console.log(data.roleid.split(","), "data.roleid.split(", ")");
			this.adduser.password = data.password;
			this.userid = data.userid;
			this.adduser.usertype = data.utype;
			if (data.utype == 'warehouse_user') {
				this.showwarehouse = true;
				this.showclient = false;
				this.adduser.clientid = '';
			} else if (data.utype == 'client_user') {
				this.showwarehouse = false;
				this.adduser.warehouseid = '';
				this.showclient = true;
			} else {
				this.adduser.warehouseid = '';
				this.adduser.clientid = '';
				this.showwarehouse = false;
				this.showclient = false;
			}
		},

		editUser() {
			if (this.checked_roleid.toString() == '') {
				return false;
			}
			if (this.adduser.fullname == '' || this.adduser.fullname == null) {
				return false;
			}
			if (this.adduser.email == '' || this.adduser.email == null) {
				return false;
			}
			if (this.checked_roleid.toString() == '' || this.checked_roleid.toString() == null) {
				return false;
			}
			if (this.adduser.usertype == '' || this.adduser.usertype == null) {
				return false;
			}
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				userid: this.userid,
				fullname: this.adduser.fullname,
				email: this.adduser.email,
				roleid: this.checked_roleid.toString(),
				modifiedby: this.localuserid,
				utype: this.adduser.usertype
			});

			if (this.adduser.usertype == 'warehouse_user') {
				if (this.adduser.warehouseid == '' || this.adduser.warehouseid == null) {
					return false;
				} else {
					this.input.warehouseid = parseInt(this.adduser.warehouseid);
					this.input.clientid = null;
				}
			} else if (this.adduser.usertype == 'client_user') {
				if (this.adduser.clientid == '' || this.adduser.clientid == null) {
					return false;
				} else {
					this.input.warehouseid = null;
					this.input.clientid = parseInt(this.adduser.clientid);
				}
			} else {
				this.input.warehouseid = null;
				this.input.clientid = null;
			}
			this.isLoading = true;
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'updateUser',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then((response) => {
					if (response.data.errorCode == 0) {
						this.$alertify.success(response.data.msg);
						this.addusermodal = false;
						this.getUserData();
						axios({
								method: 'POST',
								'url': apiUrl.api_url + 'createEncryptedJsonForAccess',
								'data': {},
								headers: {
									'Authorization': 'Bearer ' + myStr,
								}
							})
							.then((response2) => {
								if (response2.data.errorCode == 0) {
									// do nothing
								} else if (response2.data.errorCode == -1) {
									this.$alertify.error(response2.data.msg);
								}
							})
							.catch((httpException) => {
								console.error('exception is:::::::::', httpException)
							})
					} else if (response.data.errorCode == -1) {
						this.$alertify.error(response.data.msg);
					}
					this.isLoading = false;
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},

		//to get pagination
		// getPaginationData(currentPage) {
		// 	this.pageno = (currentPage - 1) * 10;
		// 	this.getUserData();
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getUserData()
		},
		//to get target id in active/inactive modal
		getStatusRowData(data) {
			this.Statusaction = 'add';
			this.modalShow = true;
			this.userid = data.userid;
			this.status = data.status;
			if (data.status == 'active') {
				this.changestatus = 'De-Activate'
			} else {
				this.changestatus = 'Activate'
			}
		},

		changeUserStatus() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'updateUserStatus',
					'data': {
						'userid': this.userid,
						'status': this.status,
					},
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then((response) => {
					if (response.data.errorCode == 0) {
						this.$alertify.success(response.data.msg);
						this.addusermodal = false;
						this.getUserData();
						axios({
								method: 'POST',
								'url': apiUrl.api_url + 'createEncryptedJsonForAccess',
								'data': {},
								headers: {
									'Authorization': 'Bearer ' + myStr,
								}
							})
							.then((response2) => {
								if (response2.data.errorCode == 0) {
									// do nothing
								} else if (response2.data.errorCode == -1) {
									this.$alertify.error(response2.data.msg);
								}
							})
							.catch((httpException) => {
								console.error('exception is:::::::::', httpException)
							})

					} else if (response.data.errorCode == -1) {
						this.$alertify.error(response.data.msg);
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},

		onSubmit: function(event) {
			this.$validator.validateAll()
				.then((result) => {
					//	if (result) {
					if (this.useraction == 'add') {
						this.saveUser();
					} else if (this.useraction == 'edit') {
						this.editUser();
					}
					//	event.target.reset();
					//console.log('form is valid', this.model);
					///	} else {
					//console.log('errors exist', this.errors);
					//	}
				}).catch(() => {
					console.log('errors exist', this.errors);
				});
		},

		resetForm() {
			this.totalRows = 0;
			this.username = '';
			this.email = '';
			this.warehouse ='';
			this.getUserData();
		},

		selectUserType(data) {
			if (data == 'warehouse_user') {
				this.showwarehouse = true;
				this.showclient = false;
				this.adduser.clientid = '';
			} else if (data == 'client_user') {
				this.showwarehouse = false;
				this.adduser.warehouseid = '';
				this.showclient = true;
			} else {
				this.adduser.warehouseid = '';
				this.adduser.clientid = '';
				this.showwarehouse = false;
				this.showclient = false;
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/user/user.component.js